// extracted by mini-css-extract-plugin
module.exports = {"title":"RouteCollectionTours_title__1k74p","container":"RouteCollectionTours_container__wdzKp","noResultsContainer":"RouteCollectionTours_noResultsContainer__2Q1s5"};